import React from "react";
import { Popover } from "antd";
import "./MrlCompoundResultsCell.css";

/**
 * Build a short preview string for MRL compound results.
 * If there are more than 2 compounds, append "and X more" to the end.
 */
const getMrlCompoundResultsForDisplay = (test) => {
  if (test.test_category !== "MRL" || !test.mrl_compounds) {
    return [];
  }

  return test.mrl_compounds
    .map((compoundRow) => ({
      compound: compoundRow.compound,
      value: compoundRow.value,
      instrumentName: compoundRow.instrument_name,
    }))
    .filter((compoundRow) => compoundRow.compound);
};

/**
 * Format a single MRL compound result line for display in column for instruments.
 * Example: "Chlorpyrifos - 0.5 (LCMS)"
 * If value is missing, omit it. If instrument name is missing, omit it.
 */
const formatMrlCompoundResultLine = ({ compound, value, instrumentName }) => {
  const valuePart = value != null && value !== "" ? ` - ${value}` : "";
  const instrumentPart = instrumentName ? ` (${instrumentName})` : "";
  return `${compound}${valuePart}${instrumentPart}`;
};

const renderCompoundLine = (compoundRow, lineKey) => (
  <div key={lineKey} className="MrlCompoundResultsCell__Line">
    {formatMrlCompoundResultLine(compoundRow)}
  </div>
);

const MrlCompoundResultsCell = ({
  testData,
  previewLimit = 2,
  compact = false,
}) => {
  if (testData.test_category !== "MRL") {
    return null;
  }

  const compoundResults = getMrlCompoundResultsForDisplay(testData);
  if (compoundResults.length === 0) {
    return <span className="MrlCompoundResultsCell__Empty">-</span>;
  }

  const previewResults = compoundResults.slice(0, previewLimit);
  const hiddenCount = compoundResults.length - previewResults.length;
  const popoverContent = (
    <div className="MrlCompoundResultsCell__PopoverContent">
      {compoundResults.map((compoundRow, index) => (
        renderCompoundLine(compoundRow, `${compoundRow.compound}-${index}`)
      ))}
    </div>
  );

  return (
    <div className={`MrlCompoundResultsCell${compact ? " MrlCompoundResultsCell--compact" : ""}`}>
      <div className="MrlCompoundResultsCell__Preview">
        {previewResults.map((compoundRow, index) => (
          renderCompoundLine(compoundRow, `${compoundRow.compound}-preview-${index}`)
        ))}
      </div>
      {hiddenCount > 0 && (
        <Popover
          trigger="click"
          placement="topLeft"
          title={`Compound-Instrument Results (${compoundResults.length})`}
          content={popoverContent}
          overlayClassName="MrlCompoundResultsCell__Popover"
        >
          <button type="button" className="MrlCompoundResultsCell__MoreButton">
            {`+${hiddenCount} more`}
          </button>
        </Popover>
      )}
    </div>
  );
};

export default MrlCompoundResultsCell;
